import { render, staticRenderFns } from "./CleaningServices.vue?vue&type=template&id=48a95172&scoped=true&"
import script from "./CleaningServices.vue?vue&type=script&lang=js&"
export * from "./CleaningServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a95172",
  null
  
)

export default component.exports